import { supabase } from "./supabaseClient";

const SERVER_URL = `http${process.env.REACT_APP_API_URL}`;

const getJWTFromLocalStorage = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session != null) {
        return session.access_token;
    }
    return null;
};

const getBackend = async (endpoint) => {
    const token = await getJWTFromLocalStorage();
    if (!token) {
        window.location.href = '/login';
        return;
    }

    const response = await fetch(`${SERVER_URL}/${endpoint}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    if (response.status === 401) {
        console.log("Unauthorized access");
        window.location.href = '/login';
        return;
    }

    if (!response.ok) {
        console.error("API error:", response.status, response.statusText);
        throw new Error('Failed to fetch incident reports');
    }
    return response;
}

export { getJWTFromLocalStorage, getBackend };